import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Utils from "../../../provider/Utils";
import { SUBSCRIPTION_TYPES } from "../../../provider/Enums";
class PreviewPlans extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
      businessType: null,
      businessUseCase: null,
      tabPlanList: [],
      planList: [],
      open: false,
    };
  }

  setKey(tab) {
    this.setState({
      selectedTab: tab,
    });
  }
  showPreviewPlanList(businessType, businessUseCase, tabPlanList, planList) {
    let planTypes = planList?.sort(
      (a, b) => a.displaySequence - b.displaySequence
    );
    let updatedPlanList = planTypes.filter(
      (plan) => plan?.status?.status !== "InActive"
    );
    this.setState({
      open: true,
      businessType: businessType,
      businessUseCase: businessUseCase,
      tabPlanList: tabPlanList,
      planList: updatedPlanList,
    });
  }

  handleClose() {
    this.setState({ open: false });
  }

  render() {
    let monthlyPlanListArr = [];
    let yearlyPlanListArr = [];
    let onetimePlanListArr = [];
    let dailyPlanListArr = [];
    let customOnetimePlanListArr = [];
    let customMonthlyPlanListArr = [];
    let customYearlyPlanListArr = [];
    let legacyOntimePlanListArr = [];
    let legacyMonthlyPlanListArr = [];
    let legacyYearlyPlanListArr = [];
    for (
      let i = 0;
      i <
      this.state.planList.sort((a, b) => a.displaysequence - b.displaysequence)
        ?.length;
      i++
    ) {
      if (
        Utils.equalsIgnoreCase(
          this.state.planList[i].planType?.type,
          SUBSCRIPTION_TYPES.payMonthly
        )
      ) {
        monthlyPlanListArr.push(this.state.planList[i]);
      } else if (
        Utils.equalsIgnoreCase(
          this.state.planList[i].planType?.type,
          SUBSCRIPTION_TYPES.payYearly
        )
      ) {
        yearlyPlanListArr.push(this.state.planList[i]);
      } else if (
        Utils.equalsIgnoreCase(
          this.state.planList[i].planType?.type,
          SUBSCRIPTION_TYPES.payOnetime
        )
      ) {
        onetimePlanListArr.push(this.state.planList[i]);
      } else if (
        Utils.equalsIgnoreCase(
          this.state.planList[i].planType?.type,
          SUBSCRIPTION_TYPES.customOnetime
        )
      ) {
        customOnetimePlanListArr.push(this.state.planList[i]);
      } else if (
        Utils.equalsIgnoreCase(
          this.state.planList[i].planType?.type,
          SUBSCRIPTION_TYPES.customMonthly
        )
      ) {
        customMonthlyPlanListArr.push(this.state.planList[i]);
      } else if (
        Utils.equalsIgnoreCase(
          this.state.planList[i].planType?.type,
          SUBSCRIPTION_TYPES.customyearly
        )
      ) {
        customYearlyPlanListArr.push(this.state.planList[i]);
      } else if (
        Utils.equalsIgnoreCase(
          this.state.planList[i].planType?.type,
          SUBSCRIPTION_TYPES.legacyOnetime
        )
      ) {
        legacyOntimePlanListArr.push(this.state.planList[i]);
      } else if (
        Utils.equalsIgnoreCase(
          this.state.planList[i].planType?.type,
          SUBSCRIPTION_TYPES.legacyMonthly
        )
      ) {
        legacyMonthlyPlanListArr.push(this.state.planList[i]);
      } else if (
        Utils.equalsIgnoreCase(
          this.state.planList[i].planType?.type,
          SUBSCRIPTION_TYPES.legacyYearly
        )
      ) {
        legacyYearlyPlanListArr.push(this.state.planList[i]);
      } else {
        dailyPlanListArr.push(this.state.planList[i]);
      }
    }
    return (
      <Dialog
        open={this.state.open}
        onClose={this.handleClose.bind(this)}
        maxWidth="xl"
        className="previewPlansDialogue"
      >
        <DialogTitle id="scroll-dialog-title">
          <span style={{ color: "#fff" }}>Preview Plans</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handleClose.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
        </IconButton>
        <DialogContent>
          <div className="row mt-2">
            <div className="col md-12">
              <div
                className="card "
                id="planDetailCard"
                style={{ background: "#fff", width: "100%" }}
              >
                <div className="col-md-8">
                  <div className="row mb-4">
                    <label
                      className="col-md-2 form-label"
                      htmlFor="multiStepsState"
                    >
                      Business Type:
                    </label>
                    <div className="col-md-10">
                      {this.state.businessType?.name}
                    </div>
                  </div>
                </div>
                <>
                  <div className="row g-3">
                    <div className="col-md-8">
                      <div className="row">
                        <label
                          className="col-md-2 form-label"
                          htmlFor="multiStepsState"
                        >
                          Use case:
                        </label>
                        <div
                          className="col-md-10"
                          style={{
                            display: "inline-block",
                          }}
                        >
                          {this.state.businessUseCase?.name}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="row mt-1">
                        <div className="row mt-1">
                          {this.state.planList?.length > 0 && (
                            <div className="col-md-12">
                              <div
                                className="content-header"
                                style={{
                                  textAlign: "left",
                                  padding: "2em 0em 0em 0em",
                                }}
                              >
                                <h3 className="m-0"> Plan options:</h3>
                              </div>
                              <div
                                className="row mt-4"
                              // style={{ margin: "auto" }}
                              >
                                <Tabs
                                  defaultIndex={this.state.selectedTab}
                                  onSelect={(k) => this.setKey(k)}
                                >
                                  <TabList
                                    style={{
                                      listStyle: "none",
                                      margin: "0",
                                    }}
                                    className="text-start d-flex justify-content-start settingTabList ps-0"
                                  >
                                    {this.state.tabPlanList.map((d, index) => (
                                      <>
                                        {d?.type !== null && (
                                          <Tab
                                            className="tabSubscription hoverTab"
                                            key={index}
                                          >
                                            {d?.description}
                                          </Tab>
                                        )}
                                      </>
                                    ))}
                                  </TabList>
                                  {this.state.tabPlanList.length > 0 &&
                                    this.state.tabPlanList.map(
                                      (d, index) =>
                                        d !== null && (
                                          <TabPanel>
                                            <div className="row d-flex align-item-stretch">
                                              {dailyPlanListArr.map(
                                                (plan, index) =>
                                                  d?.type ===
                                                  SUBSCRIPTION_TYPES.payDaily && (
                                                    <div className="col-md-3 mt-4">
                                                      <div
                                                        className="row d-flex"
                                                        style={{
                                                          height: "100%",
                                                        }}
                                                      >
                                                        <div className="col-md-12">
                                                          <div
                                                            className="box"
                                                            data-aos="zoom-in"
                                                            data-aos-delay={100}
                                                            style={{
                                                              padding: "0em",
                                                              position:
                                                                "relative",
                                                              height: "100%",
                                                            }}
                                                            id="regPlanBox"
                                                          >
                                                            <div
                                                              className="regplan-inner plan_card plan_card_bottom"
                                                              style={{
                                                                height: "100%",
                                                              }}
                                                            >
                                                              <div
                                                                className="entry-title plan_card"
                                                                style={{
                                                                  background:
                                                                    plan.colorSecondary,
                                                                }}
                                                              >
                                                                <h3
                                                                  className="plan_card"
                                                                  style={{
                                                                    padding:
                                                                      "7px",
                                                                    color:
                                                                      "#fff",
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  {plan.name}
                                                                </h3>
                                                                <div
                                                                  className="price"
                                                                  style={{
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      left: "20px",
                                                                    }}
                                                                  >
                                                                    {`$${Utils.formatWithCommas(
                                                                      plan.price
                                                                    )}`}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                              <div className="entry-content">
                                                                <ul
                                                                // style={{
                                                                //   fontSize: "small",
                                                                // }}
                                                                >
                                                                  {plan?.planItems.map(
                                                                    (
                                                                      planItem,
                                                                      index
                                                                    ) => (
                                                                      <li
                                                                        style={{
                                                                          padding:
                                                                            "0.2em",
                                                                          fontWeight:
                                                                            planItem?.isFontBold &&
                                                                            "600",
                                                                          fontStyle:
                                                                            planItem?.isFontItalic &&
                                                                            "italic",
                                                                          fontSize:
                                                                            planItem?.isFontSmall &&
                                                                            "12px",
                                                                        }}
                                                                      >
                                                                        {
                                                                          planItem.name
                                                                        }
                                                                      </li>
                                                                    )
                                                                  )}
                                                                </ul>
                                                                <div className="row p-4">
                                                                  <div className="buy_now_btn2 col-md-12 text-center">
                                                                    <div className="btn_plan1">
                                                                      <a
                                                                        style={{
                                                                          borderRadius:
                                                                            "10px",
                                                                          backgroundColor:
                                                                            plan.colorPrimary,
                                                                        }}
                                                                      // onClick={this.handleOnClickSelectedPlan.bind(
                                                                      //   this,
                                                                      //   plan
                                                                      // )}
                                                                      >
                                                                        Purchase
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                              )}
                                              {monthlyPlanListArr.map(
                                                (plan, index) =>
                                                  d?.type ===
                                                  SUBSCRIPTION_TYPES.payMonthly && (
                                                    <div className="col-md-3 mt-4">
                                                      <div
                                                        className="row d-flex"
                                                        style={{
                                                          height: "100%",
                                                        }}
                                                      >
                                                        <div className="col-md-12">
                                                          <div
                                                            className="box"
                                                            data-aos="zoom-in"
                                                            data-aos-delay={100}
                                                            style={{
                                                              padding: "0em",
                                                              position:
                                                                "relative",
                                                              height: "100%",
                                                            }}
                                                            id="regPlanBox"
                                                          >
                                                            <div
                                                              className="regplan-inner plan_card plan_card_bottom"
                                                              style={{
                                                                height: "100%",
                                                              }}
                                                            >
                                                              <div
                                                                className="entry-title plan_card"
                                                                style={{
                                                                  background:
                                                                    plan.colorSecondary,
                                                                }}
                                                              >
                                                                <h3
                                                                  className="plan_card"
                                                                  style={{
                                                                    padding:
                                                                      "7px",
                                                                    color:
                                                                      "#fff",
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  {plan.name}
                                                                </h3>
                                                                <div
                                                                  className="price"
                                                                  style={{
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      left: "20px",
                                                                    }}
                                                                  >
                                                                    {`$${Utils.formatWithCommas(
                                                                      plan.price
                                                                    )}`}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                              <div className="entry-content">
                                                                <ul
                                                                // style={{
                                                                //   fontSize: "small",
                                                                // }}
                                                                >
                                                                  {plan?.planItems.map(
                                                                    (
                                                                      planItem,
                                                                      index
                                                                    ) => (
                                                                      <li
                                                                        style={{
                                                                          padding:
                                                                            "0.2em",
                                                                          fontWeight:
                                                                            planItem?.isFontBold &&
                                                                            "600",
                                                                          fontStyle:
                                                                            planItem?.isFontItalic &&
                                                                            "italic",
                                                                          fontSize:
                                                                            planItem?.isFontSmall &&
                                                                            "12px",
                                                                        }}
                                                                      >
                                                                        {
                                                                          planItem.name
                                                                        }
                                                                      </li>
                                                                    )
                                                                  )}
                                                                </ul>
                                                                <div className="row p-4">
                                                                  <div className="buy_now_btn2 col-md-12 text-center">
                                                                    <div className="btn_plan1">
                                                                      <a
                                                                        style={{
                                                                          borderRadius:
                                                                            "10px",
                                                                          backgroundColor:
                                                                            plan.colorPrimary,
                                                                        }}
                                                                      // onClick={this.handleOnClickSelectedPlan.bind(
                                                                      //   this,
                                                                      //   plan
                                                                      // )}
                                                                      >
                                                                        Purchase
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                              )}
                                              {yearlyPlanListArr.map(
                                                (plan, index) =>
                                                  d?.type ===
                                                  SUBSCRIPTION_TYPES.payYearly && (
                                                    <div className="col-md-3 mt-4">
                                                      <div
                                                        className="row d-flex"
                                                        style={{
                                                          height: "100%",
                                                        }}
                                                      >
                                                        <div className="col-md-12">
                                                          <div
                                                            className="box"
                                                            data-aos="zoom-in"
                                                            data-aos-delay={100}
                                                            style={{
                                                              padding: "0em",
                                                              position:
                                                                "relative",
                                                              height: "100%",
                                                            }}
                                                            id="regPlanBox"
                                                          >
                                                            <div
                                                              className="regplan-inner plan_card plan_card_bottom"
                                                              style={{
                                                                height: "100%",
                                                              }}
                                                            >
                                                              <div
                                                                className="entry-title plan_card"
                                                                style={{
                                                                  background:
                                                                    plan.colorSecondary,
                                                                }}
                                                              >
                                                                <h3
                                                                  className="plan_card"
                                                                  style={{
                                                                    padding:
                                                                      "7px",
                                                                    color:
                                                                      "#fff",
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  {plan.name}
                                                                </h3>
                                                                <div
                                                                  className="price"
                                                                  style={{
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      left: "20px",
                                                                    }}
                                                                  >
                                                                    {`$${Utils.formatWithCommas(
                                                                      plan.price
                                                                    )}`}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                              <div className="entry-content">
                                                                <ul
                                                                // style={{
                                                                //   fontSize: "small",
                                                                // }}
                                                                >
                                                                  {plan?.planItems.map(
                                                                    (
                                                                      planItem,
                                                                      index
                                                                    ) => (
                                                                      <li
                                                                        style={{
                                                                          padding:
                                                                            "0.2em",
                                                                          fontWeight:
                                                                            planItem?.isFontBold &&
                                                                            "600",
                                                                          fontStyle:
                                                                            planItem?.isFontItalic &&
                                                                            "italic",
                                                                          fontSize:
                                                                            planItem?.isFontSmall &&
                                                                            "12px",
                                                                        }}
                                                                      >
                                                                        {
                                                                          planItem.name
                                                                        }
                                                                      </li>
                                                                    )
                                                                  )}
                                                                </ul>
                                                                <div className="row p-4">
                                                                  <div className="buy_now_btn2 col-md-12 text-center">
                                                                    <div className="btn_plan1">
                                                                      <a
                                                                        style={{
                                                                          borderRadius:
                                                                            "10px",
                                                                          backgroundColor:
                                                                            plan.colorPrimary,
                                                                        }}
                                                                      // onClick={this.handleOnClickSelectedPlan.bind(
                                                                      //   this,
                                                                      //   plan
                                                                      // )}
                                                                      >
                                                                        Purchase
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                              )}
                                              {onetimePlanListArr.map(
                                                (plan, index) =>
                                                  d?.type ===
                                                  SUBSCRIPTION_TYPES.payOnetime && (
                                                    <div className="col-md-3 mt-4">
                                                      <div
                                                        className="row d-flex"
                                                        style={{
                                                          height: "100%",
                                                        }}
                                                      >
                                                        <div className="col-md-12">
                                                          <div
                                                            className="box"
                                                            data-aos="zoom-in"
                                                            data-aos-delay={100}
                                                            style={{
                                                              padding: "0em",
                                                              position:
                                                                "relative",
                                                              height: "100%",
                                                            }}
                                                            id="regPlanBox"
                                                          >
                                                            <div
                                                              className="regplan-inner plan_card plan_card_bottom"
                                                              style={{
                                                                height: "100%",
                                                              }}
                                                            >
                                                              <div
                                                                className="entry-title plan_card"
                                                                style={{
                                                                  background:
                                                                    plan.colorSecondary,
                                                                }}
                                                              >
                                                                <h3
                                                                  className="plan_card"
                                                                  style={{
                                                                    padding:
                                                                      "7px",
                                                                    color:
                                                                      "#fff",
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  {plan.name}
                                                                </h3>
                                                                <div
                                                                  className="price"
                                                                  style={{
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      left: "10px",
                                                                    }}
                                                                  >
                                                                    {`$${Utils.formatWithCommas(
                                                                      plan.price
                                                                    )}`}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                              <div className="entry-content">
                                                                <ul
                                                                // style={{
                                                                //   fontSize: "small",
                                                                // }}
                                                                >
                                                                  {plan?.planItems.map(
                                                                    (
                                                                      planItem,
                                                                      index
                                                                    ) => (
                                                                      <li
                                                                        style={{
                                                                          padding:
                                                                            "0.2em",
                                                                          fontWeight:
                                                                            planItem?.isFontBold &&
                                                                            "600",
                                                                          fontStyle:
                                                                            planItem?.isFontItalic &&
                                                                            "italic",
                                                                          fontSize:
                                                                            planItem?.isFontSmall &&
                                                                            "12px",
                                                                        }}
                                                                      >
                                                                        {
                                                                          planItem.name
                                                                        }
                                                                      </li>
                                                                    )
                                                                  )}
                                                                </ul>
                                                                <div className="row p-4">
                                                                  <div className="buy_now_btn2 col-md-12 text-center">
                                                                    <div className="btn_plan1">
                                                                      <a
                                                                        style={{
                                                                          borderRadius:
                                                                            "10px",
                                                                          backgroundColor:
                                                                            plan.colorPrimary,
                                                                        }}
                                                                      // onClick={this.handleOnClickSelectedPlan.bind(
                                                                      //   this,
                                                                      //   plan
                                                                      // )}
                                                                      >
                                                                        Purchase
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                              )}
                                              {customOnetimePlanListArr.map(
                                                (plan, index) =>
                                                  d?.type ===
                                                  SUBSCRIPTION_TYPES.customOnetime && (
                                                    <div className="col-md-3 mt-4">
                                                      <div
                                                        className="row d-flex"
                                                        style={{
                                                          height: "100%",
                                                        }}
                                                      >
                                                        <div className="col-md-12">
                                                          <div
                                                            className="box"
                                                            data-aos="zoom-in"
                                                            data-aos-delay={100}
                                                            style={{
                                                              padding: "0em",
                                                              position:
                                                                "relative",
                                                              height: "100%",
                                                            }}
                                                            id="regPlanBox"
                                                          >
                                                            <div
                                                              className="regplan-inner plan_card plan_card_bottom"
                                                              style={{
                                                                height: "100%",
                                                              }}
                                                            >
                                                              <div
                                                                className="entry-title plan_card"
                                                                style={{
                                                                  background:
                                                                    plan.colorSecondary,
                                                                }}
                                                              >
                                                                <h3
                                                                  className="plan_card"
                                                                  style={{
                                                                    padding:
                                                                      "7px",
                                                                    color:
                                                                      "#fff",
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  {plan.name}
                                                                </h3>
                                                                <div
                                                                  className="price"
                                                                  style={{
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      left: "10px",
                                                                    }}
                                                                  >
                                                                    {`$${Utils.formatWithCommas(
                                                                      plan.price
                                                                    )}`}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                              <div className="entry-content">
                                                                <ul
                                                                // style={{
                                                                //   fontSize: "small",
                                                                // }}
                                                                >
                                                                  {plan?.planItems.map(
                                                                    (
                                                                      planItem,
                                                                      index
                                                                    ) => (
                                                                      <li
                                                                        style={{
                                                                          padding:
                                                                            "0.2em",
                                                                          fontWeight:
                                                                            planItem?.isFontBold &&
                                                                            "600",
                                                                          fontStyle:
                                                                            planItem?.isFontItalic &&
                                                                            "italic",
                                                                          fontSize:
                                                                            planItem?.isFontSmall &&
                                                                            "12px",
                                                                        }}
                                                                      >
                                                                        {
                                                                          planItem.name
                                                                        }
                                                                      </li>
                                                                    )
                                                                  )}
                                                                </ul>
                                                                <div className="row p-4">
                                                                  <div className="buy_now_btn2 col-md-12 text-center">
                                                                    <div className="btn_plan1">
                                                                      <a
                                                                        style={{
                                                                          borderRadius:
                                                                            "10px",
                                                                          backgroundColor:
                                                                            plan.colorPrimary,
                                                                        }}
                                                                      // onClick={this.handleOnClickSelectedPlan.bind(
                                                                      //   this,
                                                                      //   plan
                                                                      // )}
                                                                      >
                                                                        Purchase
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                              )}
                                              {customMonthlyPlanListArr.map(
                                                (plan, index) =>
                                                  d?.type ===
                                                  SUBSCRIPTION_TYPES.customMonthly && (
                                                    <div className="col-md-3 mt-4">
                                                      <div
                                                        className="row d-flex"
                                                        style={{
                                                          height: "100%",
                                                        }}
                                                      >
                                                        <div className="col-md-12">
                                                          <div
                                                            className="box"
                                                            data-aos="zoom-in"
                                                            data-aos-delay={100}
                                                            style={{
                                                              padding: "0em",
                                                              position:
                                                                "relative",
                                                              height: "100%",
                                                            }}
                                                            id="regPlanBox"
                                                          >
                                                            <div
                                                              className="regplan-inner plan_card plan_card_bottom"
                                                              style={{
                                                                height: "100%",
                                                              }}
                                                            >
                                                              <div
                                                                className="entry-title plan_card"
                                                                style={{
                                                                  background:
                                                                    plan.colorSecondary,
                                                                }}
                                                              >
                                                                <h3
                                                                  className="plan_card"
                                                                  style={{
                                                                    padding:
                                                                      "7px",
                                                                    color:
                                                                      "#fff",
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  {plan.name}
                                                                </h3>
                                                                <div
                                                                  className="price"
                                                                  style={{
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      left: "10px",
                                                                    }}
                                                                  >
                                                                    {`$${Utils.formatWithCommas(
                                                                      plan.price
                                                                    )}`}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                              <div className="entry-content">
                                                                <ul
                                                                // style={{
                                                                //   fontSize: "small",
                                                                // }}
                                                                >
                                                                  {plan?.planItems.map(
                                                                    (
                                                                      planItem,
                                                                      index
                                                                    ) => (
                                                                      <li
                                                                        style={{
                                                                          padding:
                                                                            "0.2em",
                                                                          fontWeight:
                                                                            planItem?.isFontBold &&
                                                                            "600",
                                                                          fontStyle:
                                                                            planItem?.isFontItalic &&
                                                                            "italic",
                                                                          fontSize:
                                                                            planItem?.isFontSmall &&
                                                                            "12px",
                                                                        }}
                                                                      >
                                                                        {
                                                                          planItem.name
                                                                        }
                                                                      </li>
                                                                    )
                                                                  )}
                                                                </ul>
                                                                <div className="row p-4">
                                                                  <div className="buy_now_btn2 col-md-12 text-center">
                                                                    <div className="btn_plan1">
                                                                      <a
                                                                        style={{
                                                                          borderRadius:
                                                                            "10px",
                                                                          backgroundColor:
                                                                            plan.colorPrimary,
                                                                        }}
                                                                      // onClick={this.handleOnClickSelectedPlan.bind(
                                                                      //   this,
                                                                      //   plan
                                                                      // )}
                                                                      >
                                                                        Purchase
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                              )}
                                              {customYearlyPlanListArr.map(
                                                (plan, index) =>
                                                  d?.type ===
                                                  SUBSCRIPTION_TYPES.customYearly && (
                                                    <div className="col-md-3 mt-4">
                                                      <div
                                                        className="row d-flex"
                                                        style={{
                                                          height: "100%",
                                                        }}
                                                      >
                                                        <div className="col-md-12">
                                                          <div
                                                            className="box"
                                                            data-aos="zoom-in"
                                                            data-aos-delay={100}
                                                            style={{
                                                              padding: "0em",
                                                              position:
                                                                "relative",
                                                              height: "100%",
                                                            }}
                                                            id="regPlanBox"
                                                          >
                                                            <div
                                                              className="regplan-inner plan_card plan_card_bottom"
                                                              style={{
                                                                height: "100%",
                                                              }}
                                                            >
                                                              <div
                                                                className="entry-title plan_card"
                                                                style={{
                                                                  background:
                                                                    plan.colorSecondary,
                                                                }}
                                                              >
                                                                <h3
                                                                  className="plan_card"
                                                                  style={{
                                                                    padding:
                                                                      "7px",
                                                                    color:
                                                                      "#fff",
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  {plan.name}
                                                                </h3>
                                                                <div
                                                                  className="price"
                                                                  style={{
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      left: "10px",
                                                                    }}
                                                                  >
                                                                    {`$${Utils.formatWithCommas(
                                                                      plan.price
                                                                    )}`}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                              <div className="entry-content">
                                                                <ul
                                                                // style={{
                                                                //   fontSize: "small",
                                                                // }}
                                                                >
                                                                  {plan?.planItems.map(
                                                                    (
                                                                      planItem,
                                                                      index
                                                                    ) => (
                                                                      <li
                                                                        style={{
                                                                          padding:
                                                                            "0.2em",
                                                                          fontWeight:
                                                                            planItem?.isFontBold &&
                                                                            "600",
                                                                          fontStyle:
                                                                            planItem?.isFontItalic &&
                                                                            "italic",
                                                                          fontSize:
                                                                            planItem?.isFontSmall &&
                                                                            "12px",
                                                                        }}
                                                                      >
                                                                        {
                                                                          planItem.name
                                                                        }
                                                                      </li>
                                                                    )
                                                                  )}
                                                                </ul>
                                                                <div className="row p-4">
                                                                  <div className="buy_now_btn2 col-md-12 text-center">
                                                                    <div className="btn_plan1">
                                                                      <a
                                                                        style={{
                                                                          borderRadius:
                                                                            "10px",
                                                                          backgroundColor:
                                                                            plan.colorPrimary,
                                                                        }}
                                                                      // onClick={this.handleOnClickSelectedPlan.bind(
                                                                      //   this,
                                                                      //   plan
                                                                      // )}
                                                                      >
                                                                        Purchase
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                              )}
                                              {legacyOntimePlanListArr.map(
                                                (plan, index) =>
                                                  d?.type ===
                                                  SUBSCRIPTION_TYPES.legacyOnetime && (
                                                    <div className="col-md-3 mt-4">
                                                      <div
                                                        className="row d-flex"
                                                        style={{
                                                          height: "100%",
                                                        }}
                                                      >
                                                        <div className="col-md-12">
                                                          <div
                                                            className="box"
                                                            data-aos="zoom-in"
                                                            data-aos-delay={100}
                                                            style={{
                                                              padding: "0em",
                                                              position:
                                                                "relative",
                                                              height: "100%",
                                                            }}
                                                            id="regPlanBox"
                                                          >
                                                            <div
                                                              className="regplan-inner plan_card plan_card_bottom"
                                                              style={{
                                                                height: "100%",
                                                              }}
                                                            >
                                                              <div
                                                                className="entry-title plan_card"
                                                                style={{
                                                                  background:
                                                                    plan.colorSecondary,
                                                                }}
                                                              >
                                                                <h3
                                                                  className="plan_card"
                                                                  style={{
                                                                    padding:
                                                                      "7px",
                                                                    color:
                                                                      "#fff",
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  {plan.name}
                                                                </h3>
                                                                <div
                                                                  className="price"
                                                                  style={{
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      left: "10px",
                                                                    }}
                                                                  >
                                                                    {`$${Utils.formatWithCommas(
                                                                      plan.price
                                                                    )}`}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                              <div className="entry-content">
                                                                <ul
                                                                // style={{
                                                                //   fontSize: "small",
                                                                // }}
                                                                >
                                                                  {plan?.planItems.map(
                                                                    (
                                                                      planItem,
                                                                      index
                                                                    ) => (
                                                                      <li
                                                                        style={{
                                                                          padding:
                                                                            "0.2em",
                                                                          fontWeight:
                                                                            planItem?.isFontBold &&
                                                                            "600",
                                                                          fontStyle:
                                                                            planItem?.isFontItalic &&
                                                                            "italic",
                                                                          fontSize:
                                                                            planItem?.isFontSmall &&
                                                                            "12px",
                                                                        }}
                                                                      >
                                                                        {
                                                                          planItem.name
                                                                        }
                                                                      </li>
                                                                    )
                                                                  )}
                                                                </ul>
                                                                <div className="row p-4">
                                                                  <div className="buy_now_btn2 col-md-12 text-center">
                                                                    <div className="btn_plan1">
                                                                      <a
                                                                        style={{
                                                                          borderRadius:
                                                                            "10px",
                                                                          backgroundColor:
                                                                            plan.colorPrimary,
                                                                        }}
                                                                      // onClick={this.handleOnClickSelectedPlan.bind(
                                                                      //   this,
                                                                      //   plan
                                                                      // )}
                                                                      >
                                                                        Purchase
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                              )}
                                              {legacyMonthlyPlanListArr.map(
                                                (plan, index) =>
                                                  d?.type ===
                                                  SUBSCRIPTION_TYPES.legacyMonthly && (
                                                    <div className="col-md-3 mt-4">
                                                      <div
                                                        className="row d-flex"
                                                        style={{
                                                          height: "100%",
                                                        }}
                                                      >
                                                        <div className="col-md-12">
                                                          <div
                                                            className="box"
                                                            data-aos="zoom-in"
                                                            data-aos-delay={100}
                                                            style={{
                                                              padding: "0em",
                                                              position:
                                                                "relative",
                                                              height: "100%",
                                                            }}
                                                            id="regPlanBox"
                                                          >
                                                            <div
                                                              className="regplan-inner plan_card plan_card_bottom"
                                                              style={{
                                                                height: "100%",
                                                              }}
                                                            >
                                                              <div
                                                                className="entry-title plan_card"
                                                                style={{
                                                                  background:
                                                                    plan.colorSecondary,
                                                                }}
                                                              >
                                                                <h3
                                                                  className="plan_card"
                                                                  style={{
                                                                    padding:
                                                                      "7px",
                                                                    color:
                                                                      "#fff",
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  {plan.name}
                                                                </h3>
                                                                <div
                                                                  className="price"
                                                                  style={{
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      left: "10px",
                                                                    }}
                                                                  >
                                                                    {`$${Utils.formatWithCommas(
                                                                      plan.price
                                                                    )}`}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                              <div className="entry-content">
                                                                <ul
                                                                // style={{
                                                                //   fontSize: "small",
                                                                // }}
                                                                >
                                                                  {plan?.planItems.map(
                                                                    (
                                                                      planItem,
                                                                      index
                                                                    ) => (
                                                                      <li
                                                                        style={{
                                                                          padding:
                                                                            "0.2em",
                                                                          fontWeight:
                                                                            planItem?.isFontBold &&
                                                                            "600",
                                                                          fontStyle:
                                                                            planItem?.isFontItalic &&
                                                                            "italic",
                                                                          fontSize:
                                                                            planItem?.isFontSmall &&
                                                                            "12px",
                                                                        }}
                                                                      >
                                                                        {
                                                                          planItem.name
                                                                        }
                                                                      </li>
                                                                    )
                                                                  )}
                                                                </ul>
                                                                <div className="row p-4">
                                                                  <div className="buy_now_btn2 col-md-12 text-center">
                                                                    <div className="btn_plan1">
                                                                      <a
                                                                        style={{
                                                                          borderRadius:
                                                                            "10px",
                                                                          backgroundColor:
                                                                            plan.colorPrimary,
                                                                        }}
                                                                      // onClick={this.handleOnClickSelectedPlan.bind(
                                                                      //   this,
                                                                      //   plan
                                                                      // )}
                                                                      >
                                                                        Purchase
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                              )}
                                              {legacyYearlyPlanListArr.map(
                                                (plan, index) =>
                                                  d?.type ===
                                                  SUBSCRIPTION_TYPES.legacyYearly && (
                                                    <div className="col-md-3 mt-4">
                                                      <div
                                                        className="row d-flex"
                                                        style={{
                                                          height: "100%",
                                                        }}
                                                      >
                                                        <div className="col-md-12">
                                                          <div
                                                            className="box"
                                                            data-aos="zoom-in"
                                                            data-aos-delay={100}
                                                            style={{
                                                              padding: "0em",
                                                              position:
                                                                "relative",
                                                              height: "100%",
                                                            }}
                                                            id="regPlanBox"
                                                          >
                                                            <div
                                                              className="regplan-inner plan_card plan_card_bottom"
                                                              style={{
                                                                height: "100%",
                                                              }}
                                                            >
                                                              <div
                                                                className="entry-title plan_card"
                                                                style={{
                                                                  background:
                                                                    plan.colorSecondary,
                                                                }}
                                                              >
                                                                <h3
                                                                  className="plan_card"
                                                                  style={{
                                                                    padding:
                                                                      "7px",
                                                                    color:
                                                                      "#fff",
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  {plan.name}
                                                                </h3>
                                                                <div
                                                                  className="price"
                                                                  style={{
                                                                    background:
                                                                      plan.colorPrimary,
                                                                  }}
                                                                >
                                                                  <span
                                                                    style={{
                                                                      left: "10px",
                                                                    }}
                                                                  >
                                                                    {`$${Utils.formatWithCommas(
                                                                      plan.price
                                                                    )}`}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                              <div className="entry-content">
                                                                <ul
                                                                // style={{
                                                                //   fontSize: "small",
                                                                // }}
                                                                >
                                                                  {plan?.planItems.map(
                                                                    (
                                                                      planItem,
                                                                      index
                                                                    ) => (
                                                                      <li
                                                                        style={{
                                                                          padding:
                                                                            "0.2em",
                                                                          fontWeight:
                                                                            planItem?.isFontBold &&
                                                                            "600",
                                                                          fontStyle:
                                                                            planItem?.isFontItalic &&
                                                                            "italic",
                                                                          fontSize:
                                                                            planItem?.isFontSmall &&
                                                                            "12px",
                                                                        }}
                                                                      >
                                                                        {
                                                                          planItem.name
                                                                        }
                                                                      </li>
                                                                    )
                                                                  )}
                                                                </ul>
                                                                <div className="row p-4">
                                                                  <div className="buy_now_btn2 col-md-12 text-center">
                                                                    <div className="btn_plan1">
                                                                      <a
                                                                        style={{
                                                                          borderRadius:
                                                                            "10px",
                                                                          backgroundColor:
                                                                            plan.colorPrimary,
                                                                        }}
                                                                      // onClick={this.handleOnClickSelectedPlan.bind(
                                                                      //   this,
                                                                      //   plan
                                                                      // )}
                                                                      >
                                                                        Purchase
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                              )}
                                            </div>
                                          </TabPanel>
                                        )
                                    )}
                                </Tabs>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}
export default PreviewPlans;
